var ExtendService = /** @class */ (function () {
    function ExtendService(namespace, namespaceExtension, fn) {
        this.parent = namespace;
        this.parts = namespaceExtension.split('.');
        this.callBack = fn;
        this.init();
    }
    ExtendService.prototype.init = function () {
        var _this = this;
        if (this.parts[0] === 'KILLIMANJARO') {
            this.parts = this.parts.slice(1);
        }
        this.parts.forEach(function (item, index, arr) {
            if (typeof _this.parent[item] === 'undefined') {
                _this.parent[item] = {};
                if (index === arr.length - 1) {
                    _this.parent[item] = _this.callBack || {};
                }
            }
            _this.parent = _this.parent[item];
        });
        return this.parent;
    };
    return ExtendService;
}());
export { ExtendService };



//////////////////
// WEBPACK FOOTER
// ./services/extend.service.ts
// module id = 35
// module chunks = 0